import React from 'react'
import classnames from 'classnames';
import {suitsOfCards} from './suitsOfCards'
import * as cl from './PairOfCards.module.css'

const PairOfCards = ({ className, cards }) => {
  return (
    <div className={classnames(cl.wrapper, className)}>
      {cards.map((item, index) => (
        <div
          key={index}
          className={cl.item}
        >
          <span className={cl.name}>{item.rank}</span>
          {suitsOfCards[item.suit]}
        </div>
      ))}
    </div>
  )
}

export default PairOfCards
